import { usePrincipal } from '../../../application/authentication'
import { usePaymentSchedule } from '../../../application/product/paymentScheduleContext'
import { useProposal } from '../../../application/product/proposal/proposalContext'
import { getCoreAsset, getCurrentQuote, PolicyChangeType } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../auth'

export const useProposalExcessAdjustment = (onComplete?: () => void) => {
  const { apiClient } = usePrincipal()
  const { proposal, setProposal } = useProposal()
  const { getScheduleChanges } = usePaymentSchedule()

  const quote = getCurrentQuote(proposal)

  return useApiErrorHandlingAsyncCallback(async (excess: number) => {
    const asset = getCoreAsset(quote)

    if (excess !== asset.voluntaryExcess) {
      setProposal(
        await apiClient.updateProposal(proposal.proposalCode, {
          applyRating: true,
          changes: [
            ...getScheduleChanges(),
            {
              changeType: PolicyChangeType.SELECT_VOLUNTARY_EXCESS,
              excess,
            },
          ],
        }),
      )
    }

    onComplete?.()
  })
}
